/**
 * 
 * @param {string} dir is a directory within the public/images directory 
 * @param {string} fileNames are all the file names within the above directory
 * @returns 
 */
export async function getImageUrls(dir){
    const res = await fetch(`/images/${dir}/images.json`);
    const files = await res.json();
    return files.map(file => `/images/${dir}/${file}`);
}